import { FoodfluenceLocation, GetClientLocationsResponse } from '@foodfluence/shared';
import { apiRequest } from './apiUtils';

/**
 * Get locations for a client
 */
export const getLocationsForClient = async (clientId: string): Promise<GetClientLocationsResponse> => {
  try {
    const response = await apiRequest<GetClientLocationsResponse>({
      method: 'GET',
      endpoint: `/clients/${clientId}/locations`
    });
    return response;
  } catch (error) {
    console.error('Error fetching client locations:', error);
    return {
      success: false,
      data: [],
      count: 0,
      error: error instanceof Error ? error.message : 'Failed to fetch client locations'
    };
  }
}; 